// src/domains/settings.leave.ts —— 系统参数页「未保存修改」离开拦截（2026-10-15 运营 UX 评审 P0 #3）
// 独立小模块：外壳 go() 依赖本函数，而 settings.ts 依赖 gp.ts → shell.ts，直接互引会成环
import type { Page } from '../state';
import type { AdminCtx } from './types';

// 当前在系统参数页且有未保存修改、目标是别的页 → 记下目标页并打开页面内确认框，返回 true（调用方不得切页）
export function interceptSettingsLeave(ctx: AdminCtx, to: Page): boolean {
  const s = ctx.host.state;
  if (s.page !== 'settings' || to === 'settings' || !s.st.dirty) return false;
  ctx.host.setState({ st: { ...s.st, leaveTo: to } });
  return true;
}
